<template>
<div class="container-fluid">

<h4><strong>REGISTRAZIONE ORDINE VARIANTI PRODOTTO</strong></h4>
<product-info v-bind:productId="product.productId"></product-info> 

<customSizes v-if="product.barcodes.length == 0" v-bind:props = "product" @update="setCustomSizeList"></customSizes>
<product-stock-history v-if="showStockHistory" @close="showStockHistory=false" v-bind:productId="product.productId"></product-stock-history>

<button   data-toggle="tooltip" title="Lista varianti già acquistate." class="btn btn-outline-info mr-2 mb-2"  @click="showStockHistory=true">
      <i class="fas fa-binoculars mr-2" aria-hidden="true"></i>
      LISTA VARIANTI GIA' ACQUISTATE
</button> 

<button type="button" @click="setTables()"  class="btn btn-outline-info mb-2 ml-2">
  <i style="color:blue" v-bind:class="show ? 'far fa-eye-slash' : 'far fa-eye'" class="mr-2" aria-hidden="true"></i>
  {{show ? 'NASCONDI ' : 'MOSTRA'}} TABELLE</button>
 
<div v-if="show">
<div class="row">
    <div class="col-sm-3">
        <color-list v-bind:selection="productColors"  @update="setColorList"></color-list>
    </div>
    <div class="col-sm-9">
        
        <sizes-list v-if="sizeSystem" @swap="sizeSystem=false" v-bind:selection="productSizes" @update="setSizeList"></sizes-list>

        <company-size-list v-else @swap="sizeSystem=true" size-list v-bind:selection="productSizes" @update="setSizeList"></company-size-list> 
    </div>  
</div>
</div>


<div class="card border border-success">
<!-- TABLE -->

<div class="table-responsive">              
  <table class="table table-bordered table-sm" id="dataGrid">
    <thead class="thead-light">
      <tr>
        <th class="text-center"
         v-bind:style="{ color: index > 0 ? 'black':'blue', backgroundColor : index > 0 ? '#9ACD32':'' }"
         v-for="(key,index) in cols" :key="index">        
          <span 
           v-bind:style="{ color:  key!='COLORE'? 'black':'blue'}"
           >{{key}}</span>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr  v-for="(item, index) in rows" :key="index">
        <td v-for="(key,index2) in cols" :key="index2" >
        <div style='color:blue' v-if = "key == 'COLORE'" >
        <div class="form-group row">
            <div class="col">
                
                <div class="col">
                  <i v-if="index==0" class='fas fa-clone mr-1 clone' data-toggle="tooltip" title="Copia quantità colore" @click="clone(item)"  aria-hidden="true"></i> 
                  <span for="staticColor" class="col-sm-2 _col-form-label text-nowrap"><strong>{{item[key]}}</strong>
                    
                    <span  style="font-size: 20px;" class="badge badge-success float-right">{{ rowTotal[index] }}</span>
                  </span>               
                  
                </div>

                <div class="col">
                  <input  v-model = "item['supplierColor']" class="form-control form-control-sm inputClass" type="text"  :placeholder="'Codice colore fornitore'">       
                </div>
                
            </div>
        </div>
        
        </div> 

         <input v-else v-on:keydown="keyHandler($event,'Num')" v-model = "item[key]" class="form-control form-control-sm inputClass" type="number"  :placeholder="''" :disabled="key=='Colore'">
        </td>
      </tr>
    </tbody>
  </table>

<!-- Table -->
 </div>
</div>  


  <h3 v-if="rows.length > 0 && cols.length > 0" class="text-center">Totale  <span class="badge badge-danger">{{total}}</span></h3>
  <alert-box class="mt-2 mb-2"  @close="msg.title=''" v-bind:msg="msg"  ></alert-box>  
  
  <button @click="$emit('back')"  class="btn btn-secondary float-left ">
     <i style="color:yellow" class="fas fa-reply mr-2" aria-hidden="true"></i>
    RITORNA A REGISTRAZIONE PRODOTTO</button>

  <button @click="submit()"  class="btn btn-primary float-right mr-4">
     <i class="fas fa-arrow-circle-right mr-2" aria-hidden="true"></i>
    PROCEDI</button>
 
</div> 
</template>

<script>
import api                         from '@/api'
import alertBox                    from '@/components/common/AlertBox.vue';
import {eanCD,createEAN13}         from '@/functions';   
//import sizeList                    from '@/components/order/SizeList.vue';
import sizesList                   from '@/components/backOffice/ready/SizesList.vue';
import colorList                   from '@/components/order/ColorList.vue';
import productInfo                 from '@/components/product/ProductInfo.vue';
import keyHandler                  from '@/components/mixins/keyHandler'
import customSizes                 from '@/components/backOffice/ready/CustomSizeList.vue';
import companySizeList             from '@/components/backOffice/ready/CompanySizesList.vue';
import productStockHistory         from '@/components/backOffice/ready/ProductStockHistory.vue'

export default {
   mixins: [keyHandler],
   components: {sizesList,colorList,alertBox,productInfo,customSizes,companySizeList,productStockHistory
     
  },
  props : ['product'],
  data () {
    return {     
      
      showStockHistory      : false,
      sizeSystem            : false,
      show                  : true,
      rows                  : [],
      cols                  : [],
      productColors         : [],
      productSizes          : [],
      total                 : 0,
      msg                   : {
        title : '',
        body  : '',
        type  : 1
        
      },
      
      

     
      sizes                 : [],
      colors                : [],
      barcodes              : [],
      counter               : this.product.counter,
      customSizeList        : [],
      rowTotal              : [], 
      supplierColorCodes    : []
       
      
    }
  },

  computed: 
  {   
    
   
   
  },

  created()
  {  
  
    console.log(this.product)
    
  },

  watch: 
  {
        
    'rows' : 
    {
      
      deep: true,  
      
      handler : function(newValue) 
      {                
        this.total = 0
        this.rowTotal = []
        for(var i = 0; i < newValue.length; i++) 
          {
            var obj = newValue[i];
            this.rowTotal[i]=0
            Object.entries(obj).forEach(entry => 
            {
              let key = entry[0];
              let value = entry[1];
              if (key != 'colorId' && key != 'COLORE' && key != "supplierColor")
              {
                this.total += Number(value)
                this.rowTotal[i] += Number(value)
              }
                      
            });  
          }                
      }

    }
    
  
  },
      
  async mounted()
  {
    
    this.supplierColorCodes = await this.getSupplierColorCodes()     
    console.log(this.supplierColorCodes)
  },
  methods: 
  {
    //...mapActions(['createStockGrid']),
    getSupplierColorCodes()
    {

    const data     = {'supplierId' : this.product.supplierId}    
    const sp       = {'sp' : 'spSupplierColorCodes'}
    const json     = Object.assign(data, sp);

         return new Promise( async (resolve, reject)  =>  {

         await api.post(json).then(res => {
          if(res.status==200)
            {
              resolve(res.data.recordsets[0])
              
            }
            else if(res.status==500)
            {
                             
               resolve([])       
            } 
            else
            {
              
              resolve([])       
              
            } 
        }).catch(err => 
        {
          

          resolve([])       
           

        }).finally(() => {
          
        });   


         })  

      

    },
    setCustomSizeList(sizes)
    {
      
      if(this.product.barcodes.length == 0)
      {
        if(sizes.length>0)
        {
          
          sizes.forEach(item =>
          {
            
            item.selected = 1
            //delete item.newSize 
          })

          
          this.customSizeList = sizes
          this.productSizes = sizes
          this.setTables()
          this.createGrid(this.productColors,this.productSizes)

        }
      }
      

    },
    clone(obj)
    {      
       
      

       let data    = obj
       Object.entries(data).forEach(item => 
            {
             
              let key = item[0]
              let value = item[1]
              
               if (key != 'colorId' && key != 'COLORE' && key != "supplierColor")
               {                                        
                this.rows.forEach(row =>
                  {  
                    
                    row[key] = value                             

                  })
               }
            
            });
       
    },
   


    setTables()
    {
         
      this.show = !this.show
      this.$nextTick(function () {
        $('input:visible:enabled:first').focus(); 
      })
           
    },

    copyQty()
    {

    },
    setColorList(colors)
    {
      this.productColors = colors
      this.createGrid(this.productColors,this.productSizes)
      
      
    },
    setSizeList(sizes)
    {
      sizes.forEach(item=>{
        item.new = 'yes'
      })
      this.productSizes = sizes
      this.createGrid(this.productColors,this.productSizes)
      

    },
    createGrid(colors,sizes)
    {

      this.cols = []
      this.rows = []
      
      
      this.cols.push('COLORE')

		  sizes.forEach(item =>
      {
			  this.cols.push(item.size)
      }) 
					
      
      colors.forEach(item =>
      { 
        let supplierColor = ''
        this.supplierColorCodes.forEach(color => {
          if(item.colorId == color.colorId)
          {
            supplierColor = color.color
          }
        });      
        const obj = {'colorId': item.colorId ,'COLORE' : item.color,'supplierColor':supplierColor}

         sizes.forEach(size=>{
          obj[size.size]= ''
        })
              
        this.rows.push(obj)
      })

      
      
    },

   
   submit() 
    {
      

      this.msg.title = ''
      if(this.total == 0)
      {

        this.msg.title = 'ATTENZIONE '
        this.msg.body = 'Nessuna quantità Colore/Misura inserita.'
        this.msg.type = 1

        return
      }

      
      this.createBarcodes()
      
    
      this.$emit('update',this.barcodes,this.productSizes,this.counter)
      
      
    },  
   
    
   
    
    getBarcode(productId,colorId,sizeId)
    {
      //console.log('Product Barcodes',this.product.barcodes)
      var item = this.product.barcodes.filter(item => (item.productId == productId && item.colorId == colorId && item.sizeId == sizeId) )
      
      if(item.length>0)
      {
        return item[0].barcode
      }
      else
      {
        return ''
      }
    },
    createBarcodes: function()
    {
      
      // ProductId passed as PROPS
      const productId     = this.product.productId
      var obj             = {}
      this.barcodes       = []
      
      //var  counter        = this.product.counter
            

      // RIGHE COLORE
      this.rows.forEach(item => 
      {
        // barcode counter      
        this.productSizes.forEach(col =>
        {
          var key     = col.size
          var sizeId  = col.sizeId
          var val     = item[key]
          if(Number(val)>0)
          {
            obj                    = {colorId:item.colorId,color:item.COLORE}
            obj['size']            = key  
            obj['sizeId']          = sizeId
            obj['qty']             = val
            var barcode            = this.getBarcode(productId,obj.colorId,obj.sizeId)   

            // new barcode       
            if(barcode.length == 0)
            {
              this.counter++
            }

            obj['barcode']         = barcode.length > 0 ? barcode : createEAN13(productId,this.counter)
            obj['productId']       = productId
            obj['costPrice']       = ''
            obj['retailPrice']     = ''
            obj['ean_13']          = ''
            obj['supplierColor']   = item.supplierColor
            obj['discount']        = 0
            obj['vat']             = 0
            this.barcodes.push(obj)
          
          } 
      })          
      })
      
      //console.log('BARCODES',this.barcodes)
      
    },
      

    }
  
}
</script>

<style scoped>
.inputClass{
  font-weight       : bold;
  
  }
.misura
{
  color        : coral;
  font-size    : 12px;
}

input[type=text]:disabled {
  background : white;
  color      : navy
}
h4 {
  font-family: 'Roboto Condensed';
  font-size: 18px;
}

.clone {
  cursor:pointer;
  color :blueviolet;
}
</style>